/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { NotificationSelectionSummaryRequestViewModel } from "../types/NotificationSelectionSummaryRequestViewModel.ts";

export const notificationSelectionSummaryRequestViewModelSchema = z.object({
  classStudentIds: z
    .array(z.number().int())
    .describe(
      "IDs das turmas selecionadas. Obrigatório quando IsAllClassStudents = false. Ignorado quando IsAllClassStudents = true.",
    )
    .nullish(),
  enrollmentStatus: z
    .array(z.number().int())
    .describe(
      "Status de matrícula para filtrar os alunos. Obrigatório. Ao menos um valor deve ser informado. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
    )
    .nullish(),
  isAllClassStudents: z.optional(
    z
      .boolean()
      .describe(
        "Quando true, considera todas as turmas ativas e ignora ClassStudentIds. Default: false.",
      ),
  ),
}) as unknown as ToZod<NotificationSelectionSummaryRequestViewModel>;
